import * as React from 'react';

function SvgFlagStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.736 15.442c-1.7-.69-3.095-.62-6.327.037-2.933.596-4.528.75-6.17.294V25.86a.7.7 0 11-1.4 0V5.666a.696.696 0 01.978-.643c1.692.685 3.089.613 6.313-.043 3.496-.71 5.092-.792 7.133.038a.7.7 0 01.437.648v9.127a.7.7 0 01-.964.649zM9.238 6.646v7.661c1.52.512 2.94.4 5.892-.2 2.932-.596 4.527-.749 6.17-.294v-7.66c-1.52-.512-2.939-.4-5.891.2-2.933.595-4.528.749-6.17.293z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgFlagStroke;
